import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { GlobalService } from "src/app/services/global/global.service";

import { MEGStoreService } from "src/app/services/meg/meg-store.service";
@Component({
	selector: "dmv-privacy",
	templateUrl: "./privacy.component.html",
	styleUrls: ["./privacy.component.css"]
})
export class PrivacyComponent implements OnInit {
	constructor(
		public megStoreService: MEGStoreService,
		public globalService: GlobalService
	) {}
	public isPopupOpen: boolean = true;

	@Output() public closePopup: EventEmitter<any> = new EventEmitter();
	@Input() public privacyPolicy: string;

	ngOnInit() {}
	public close() {
		this.isPopupOpen = false;
		this.closePopup.emit();
	}
}
